export default function Settings() {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">Settings</h2>
        <p className="text-slate-500 dark:text-slate-400">Manage your preferences</p>
      </div>
    </div>
  );
}
